require('../../styles/blocks/_messages-screen.scss');
const React = require('react');
const RoadmapNavigation = require('components/steps/roadmapNavigation').RoadmapNavigation;

class MessagesScreen extends React.Component {
    constructor(props) {
        super(props);

        this.onHandleButtonActions = this.onHandleButtonActions.bind(this);
    }

    UNSAFE_componentWillMount() {
        window.scrollTo(0, 0);
    }

    onHandleButtonActions() {
        const { action, buttonClass, buttonText, showRoadmapNavigation, roadmapNavigationProps } = this.props;

        if (!showRoadmapNavigation) {
            return (
                <div className="form__buttons">
                    <button type="button" className={buttonClass} onClick={action}>
                        {buttonText}
                    </button>
                </div>
            );
        }

        return (
            <div>
                <RoadmapNavigation {...roadmapNavigationProps} />
            </div>
        );
    }

    subtitleDash() {
        const { dashTitle, subtitle } = this.props;
        let sub;
        if (!dashTitle) {
            sub = (
                <div>
                    <p className="font-paragraph1">{subtitle}</p>
                    <span className="dash" />
                </div>
            );
        } else {
            sub = (
                <div>
                    <span className="dash" />
                    <p className="font-paragraph1">{subtitle}</p>
                </div>
            );
        }

        return sub;
    }

    render() {
        const { iconClass, title, showFooter } = this.props;
        const buttonActions = this.onHandleButtonActions();
        const subtitleDash = this.subtitleDash();

        return (
            <div>
                <div className="prospects-gutter prospects-prepend-margin">
                    <div className="prospects-gutter prospects-gutter-MessageContainer">
                        <div className="messages-container">
                            <div className="icon-container">
                                <i className={iconClass}></i>
                            </div>
                            <div className="text-container">
                                <h2 className="font-heading2">{title}</h2>
                                {subtitleDash}
                                <div className="childern">{this.props.children}</div>
                            </div>
                        </div>
                    </div>
                </div>
                {showFooter && <div className="form__footer">{buttonActions}</div>}
            </div>
        );
    }
}

MessagesScreen.defaultProps = {
    iconClass: 'icon',
    title: '',
    subtitle: '',
    action: null,
    buttonText: '',
    buttonClass: 'form__button form__button-primary',
    showRoadmapNavigation: false,
    roadmapNavigationProps: {},
    style: {},
    dashTitle: false,
    showFooter: true,
};
module.exports = MessagesScreen;
